/**
 * Created by youzipi on 17/8/11.
 */


import productApi from '../../api/product'
import * as types from '../mutation-types'

export default {
  // namespaced: true,
  state: {
    // 当前城市 产品列表
    products: [],
    /**
     * ex:
     * [
     *  {
     *    code:PS,
     *    title:创业套餐,
     *    children:[
     *      {
     *        title:套餐,
     *        products:[
     *
     *          ]
     *        },
     *        ...
     *    ]
     *  },
     *  ...
     * ]
     */
    navProducts: [],
    CATEGORY_ORDER: [
      'PS',
      'IC',
      'QF',
      'FC',
      'LD',
      'HR',
      'IT',
    ],
    CATEGORY_CODE: {
      PS: '创业套餐',
      IC: '工商服务',
      QF: '资质办理',
      FC: '财税服务',
      LD: '法律服务',
      HR: '人事服务',
      IT: 'IT&设计',
      // TP: '税务筹划',
    },
    CATEGORY_REMARKS: {
      PS: '新公司成立怎么做代账',
      IC: '经营地址如何变更企业法人变更',
      QF: '上海办理道路运输经营许可证办理_就上企业湾',
      FC: '代理记账公司一般为多少家公司服务包含多少服务项目',
      LD: '合同撰写与审查商标查询网站',
      HR: '挂靠社保怎么代缴哪家可靠，代缴社保费用多少钱',
      IT: 'IT&做网站大约需要多少钱',
      TP: '',
    },
  },
  mutations: {
    [types.SAVE_PRODUCTS](state, {products}){
      if (__DEV__) {
        // debugger
      }
      state.products = products
      let navProducts = _.chain(products)
        .groupBy('classificationCode')
        .map((_products, code) => {
          let value = _.chain(_products)
            .groupBy('classificationName')
            .map((_products, name, remark) => {
              return {
                title: name,
                products: _products,
                remarks: remark
              }
            })
            .value()
          return {
            title: state.CATEGORY_CODE[code],
            code: code,
            children: value,
            remarks: state.CATEGORY_REMARKS[code]
          }
        })
        .sortBy(item => {
          return state.CATEGORY_ORDER.indexOf(item.code)
        })
        .value()
      // i.l.list = _.sortBy(data.filter(item => i.l.title === item.classificationName), ['heat', 'name']).reverse()


      state.navProducts = navProducts
    },
  },
  getters: {
    getNavProducts(state){
      return state.navProducts
    },
    getCategories(state){
      return state.navProducts
    },
    getProducts(state, getters, rootState, rootGetters){
      return state.products
    },
    relatedProducts(state, getters, rootState, rootGetters){

      /**
       * find products by classificationCode
       * @param code {String} classificationCode
       * @returns {Array}
       * @private
       */
      let _fn = code => {
        if (code) {
          return _.chain(state.products)
            .filter(p => p.classificationCode === code)
            .groupBy(p => p.classificationName)
            .value()
        }
        else {
          return []
        }
      };
      return _fn
    },
    searchProduct(state, getters, rootState, rootGetters){
      /**
       * 按关键字 搜索产品
       * 搜索范围仅限当前城市
       * @param keyword {String}
       * @returns {Array}
       * @private
       */
      let _searchFn = keyword => {
        if (keyword) {
          return _.filter(state.products,
            p => p.name.indexOf(keyword) >= 0
          )
            .map(p => {
              return {
                name: p.name.replace(keyword, `<em>${keyword}</em>`),
                serialId: p.serialId,
                heat: p.heat,
                classificationName: p.classificationName,
                classificationCode: p.classificationCode,

              }
            })
        }
        else {
          return []
        }
      };
      return _searchFn
    }
  },
  actions: {
    async fetchProducts({state, rootState, commit, dispatch, getters}, regionCode){
      // async fetchProducts({state, rootState, commit, dispatch, getters}){
      //   let regionCode = rootState.region
      let products = await productApi.getNavList(regionCode)
      products = _.orderBy(products, ['heat', 'isHot', 'name'], ['desc', 'desc', 'desc'])
      commit(types.SAVE_PRODUCTS, {
        products: products
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/module/product.js